var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNotFound42(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 111,
    height: 221,
    viewBox: "0 0 111 221",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37 111L-7.62939e-06 111L3.26078e-07 20L37 20L37 111Z",
    fill: "#03677C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M110.5 110.5L73.6667 110.5L73.6667 -3.22007e-06L110.5 0L110.5 110.5Z",
    fill: "#03677C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M110.5 221L73.6667 221L73.6667 110.5L110.5 110.5L110.5 221Z",
    fill: "#03677C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0 110.5L0 73.6667L110.5 73.6667V110.5L0 110.5Z",
    fill: "#03677C"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotFound42);
export default __webpack_public_path__ + "static/media/not-found-4-2.e0b8ac0fa95d576038753d5cde700af2.svg";
export { ForwardRef as ReactComponent };